/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Download = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 24 24">
      <path
        d="M12 15.575C11.8667 15.575 11.7417 15.5543 11.625 15.513C11.5083 15.4717 11.4 15.4007 11.3 15.3L7.7 11.7C7.51667 11.5167 7.425 11.2833 7.425 11C7.425 10.7167 7.51667 10.4833 7.7 10.3C7.88333 10.1167 8.121 10.021 8.413 10.013C8.705 10.005 8.94234 10.0923 9.125 10.275L11 12.15V5C11 4.71667 11.096 4.479 11.288 4.287C11.48 4.095 11.7173 3.99934 12 4C12.2833 4 12.521 4.096 12.713 4.288C12.905 4.48 13.0007 4.71734 13 5V12.15L14.875 10.275C15.0583 10.0917 15.296 10.004 15.588 10.012C15.88 10.02 16.1173 10.116 16.3 10.3C16.4833 10.4833 16.575 10.7167 16.575 11C16.575 11.2833 16.4833 11.5167 16.3 11.7L12.7 15.3C12.6 15.4 12.4917 15.471 12.375 15.513C12.2583 15.555 12.1333 15.5757 12 15.575ZM6 20C5.45 20 4.979 19.804 4.587 19.412C4.195 19.02 3.99934 18.5493 4 18V16C4 15.7167 4.096 15.479 4.288 15.287C4.48 15.095 4.71733 14.9993 5 15C5.28333 15 5.521 15.096 5.713 15.288C5.905 15.48 6.00067 15.7173 6 16V18H18V16C18 15.7167 18.096 15.479 18.288 15.287C18.48 15.095 18.7173 14.9993 19 15C19.2833 15 19.521 15.096 19.713 15.288C19.905 15.48 20.0007 15.7173 20 16V18C20 18.55 19.804 19.021 19.412 19.413C19.02 19.805 18.5493 20.0007 18 20H6Z"
        fill="black"
      />
    </BaseSvgIcon>
  )
}

export default Download
